import { useNavigate, useParams, Link} from "react-router-dom";
import { useContext, useEffect, useState, useRef } from "react";
import { GlobalInfo } from "../../../../../Contexts/GlobalContext";
import { LabsService } from "../../../../../Services/Labs.service";
import TokenService from "../../../../../Services/Token.service";
import Toaster from "../../../../../Components/Toaster";
import { Formik, Form, Field, ErrorMessage  } from "formik";
import * as Yup from "yup";
import Loader from "../../../../../Components/Loader";
import ReactDatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

const initialHours = {
    Sunday: { enabled: false, slots: [{ open: '', close: '', valid: true }] },
    Monday: { enabled: false, slots: [{ open: '', close: '', valid: true }] },
    Tuesday: { enabled: false, slots: [{ open: '', close: '', valid: true }] },
    Wednesday: { enabled: false, slots: [{ open: '', close: '', valid: true }] },
    Thursday: { enabled: false, slots: [{ open: '', close: '', valid: true }] },
    Friday: { enabled: false, slots: [{ open: '', close: '', valid: true }] },
    Saturday: { enabled: false, slots: [{ open: '', close: '', valid: true }] },
};


function LabEdit() {
    const { id } = useParams();
    const navigate = useNavigate();
    const { appUserIsLogin, theme, toggleSidebar, isSidebarVisible } = useContext(GlobalInfo);
    const [showToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const [toastVariant, setToastVariant] = useState('');
    const [loading, setLoading] = useState(false);
    const previousUrl = TokenService.getPrevLink();  
    const [initialValues, setInitialValues] = useState(null);
    const [days, setDays] = useState([]);
    const [hours, setHours] = useState(initialHours);
    const codeRef = useRef(null);

    const validateSlots = (hours) => {
        let isValid = true;
    
        const updatedHours = { ...hours };
    
        for (const day in updatedHours) {
            const { enabled, slots } = updatedHours[day];

            // Skip validation if the day is disabled
            if (!enabled) continue;
    
            // Reset all slots to valid initially
            slots.forEach(slot => (slot.valid = true));
    
            // Check for empty or overlapping slots
            for (let i = 0; i < slots.length; i++) {
                const slotA = slots[i];
                if (!slotA.open || !slotA.close || slotA.close <= slotA.open) {
                    slotA.valid = false; // Mark invalid if time is empty
                    isValid = false;
                }
    
                for (let j = i + 1; j < slots.length; j++) {
                    const slotB = slots[j];
                    if (
                        slotA.open < slotB.close &&
                        slotA.close > slotB.open
                    ) {
                        slotA.valid = false;
                        slotB.valid = false; // Mark both overlapping slots as invalid
                        isValid = false;
                    }
                }
            }
        }
    
        setHours(updatedHours); // Update state to reflect validation results
        return isValid;
    };

    const handleToggle = (day) => {
        const updatedHours = { ...hours };
        updatedHours[day].enabled = !updatedHours[day].enabled;
        setHours(updatedHours);
    };

    const handleInputChange = (day, index, field, value) => {
        const updatedHours = { ...hours };
        updatedHours[day].slots[index][field] = formatTime(value);
        setHours(updatedHours);
    };

    const addTimeSlot = (day) => {
        const updatedHours = { ...hours };
        updatedHours[day].slots.push({ open: '', close: '' });
        setHours(updatedHours);
    };

    const removeTimeSlot = (day, index) => {
        const updatedHours = { ...hours };
        updatedHours[day].slots.splice(index, 1);
        setHours(updatedHours);
    };

    const renderTimeSlots = (day) => (
        hours[day].slots.map((slot, index) => {
                  
            const currentDate = new Date(); // Get the current date
            
            const openTime = slot.open ? 
                slot.open instanceof Date ? new Date(currentDate.setHours(slot.open.getHours(), slot.open.getMinutes())) : new Date(currentDate.setHours(...slot.open.split(":")))
                : null;

            const closeTime = slot.close
                ? slot.close instanceof Date  
                    ? new Date(currentDate.setHours(slot.close.getHours(), slot.close.getMinutes()))
                    : new Date(currentDate.setHours(...slot.close.split(":")))
                : null;

            const maxCloseTime = openTime ? new Date(openTime.getFullYear(), openTime.getMonth(), openTime.getDate(), 23, 45, 0) : null;

            return(  
                <div className="row col-md-12 mb-2 el-add-hours align-items-center" key={index}>
                    <div className="col-md-5 mb-2">
                        <label htmlFor="openslot" className="form-label">Open At <span className="text-danger">*</span></label>
                        <ReactDatePicker
                            selected={openTime}
                            onChange={(date) => handleInputChange(day, index, 'open', date)}
                            showTimeSelect
                            showTimeSelectOnly
                            timeIntervals={15} // Increment by 15 minutes
                            timeCaption="Time"
                            dateFormat="h:mm aa"
                            className={`form-control ${!slot.valid ? 'invalid' : ''}`}
                            placeholderText="Select time"
                            onKeyDown={(e) => e.preventDefault()}
                        />                
                    </div>
                    <div className="col-md-5 mb-2">
                        <label htmlFor="closeslot" className="form-label">Close At <span className="text-danger">*</span></label>
                        <ReactDatePicker
                            selected={closeTime}
                            onChange={(date) => handleInputChange(day, index, 'close', date)}
                            showTimeSelect
                            showTimeSelectOnly
                            timeIntervals={15} // Increment by 15 minutes
                            timeCaption="Time"
                            dateFormat="h:mm aa"
                            minTime={openTime}
                            maxTime={maxCloseTime} 
                            className={`form-control ${!slot.valid ? 'invalid' : ''}`}
                            placeholderText="Select time"
                            onKeyDown={(e) => e.preventDefault()}
                        /> 
                    </div>
                    <div className="col-md-2 remove-btn-wrapper">
                        {index !== 0 && (                    
                    <button
                    type="button"
                    className="text-danger ms-3"
                    onClick={() => removeTimeSlot(day, index)}
                    ><i className="el-icon-trash"></i></button>
                        )}


                    </div>  
                </div>
            );
        })
    );

    // Validation Schema using Yup
    const validationSchema = Yup.object().shape({
        lab_name: Yup.string()
                    .required('Lab name is required')
                    .max(50, "Lab name must be at most 50 characters")
                    .matches(/^[a-zA-Z0-9\s]*$/, "Lab name can only contain letters and numbers"),
        lab_code: Yup.string()
                    .required('Lab code is required')
                    .max(10, "Lab code must be at most 10 characters")
                    .matches(/^[a-zA-Z0-9]+$/, "Lab code can only contain letters and numbers (no white spaces)"),
        address: Yup.string()
                    .nullable()
                    .max(200, "Address must be at most 200 characters")
                    .matches(
                        /^[a-zA-Z0-9\s,.'-]*$/,
                        "Address can only contain letters, numbers, spaces, commas, periods, apostrophes, and dashes"
                    ),
        city: Yup.string()
                    .nullable()
                    .max(100, "City must be at most 100 characters")
                    .matches(/^[a-zA-Z\s]*$/, "City can only contain letters"),
        state: Yup.string()
                    .nullable()
                    .max(100, "State must be at most 100 characters")
                    .matches(/^[a-zA-Z\s]*$/, "State can only contain letters"),      
        country: Yup.string()
                    .nullable()
                    .max(100, "Country must be at most 100 characters")
                    .matches(/^[a-zA-Z\s]*$/, "Country can only contain letters"),
        postalcode: Yup.string()
                    .nullable()
                    .max(6, "Postal code must be at most 6 characters")
                    .matches(/^\d{5}(-\d{4})?$/, "Postal Code must be a valid"),  
    });

    useEffect(() => { 
        fetchLabDetail(id);
    }, [id]); 

    const fetchLabDetail = async (id) => {
        setLoading(true);
        try {
            LabsService.fetchLabDetail(id)
            .then(response => {                
                const lab = response.lab;
                setInitialValues({
                    lab_name: lab.name,                    
                    lab_code: lab.code,
                    address: lab.address,
                    city: lab.city,
                    state: lab.state,
                    country: lab.country,
                    postalcode: lab.postalcode,
                    hours: lab.working_hours
                });   
                setHours(response.working_hours);
            })
            .catch(error => {
                setToastMessage('Error fetching lab details');
                setShowToast(true);
                setToastVariant('error');
                console.log("Error fetching lab details:", error);
            });

        } catch (error) {
            setToastMessage(error.message || 'Something went wrong.');
            setShowToast(true);
            setToastVariant('error');
        } finally {
            setLoading(false);
        }
    };

    const handleCodeChange = (event, setFieldValue) => {
        const upperCaseValue = event.target.value.toUpperCase();
        if (codeRef.current) {
            codeRef.current.value = upperCaseValue;
        }
        setFieldValue('lab_code', upperCaseValue); // Update Formik's state
    };

    function formatTime(time) {
        if (!time) return null;
    
        const date = new Date(time);
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        return `${hours}:${minutes}`;
    }

    const handleSubmit = async (values) => {

        setLoading(true);
        
        if (!validateSlots(hours)) {
            setToastMessage('Please fix the highlighted slot errors.');
            setToastVariant('error');
            setShowToast(true);
            setLoading(false);
            return; // Stop submission if validation fails
        }

        let working_hours = {};
        if(Object.entries(hours).length > 0) {
            working_hours = Object.fromEntries(
                Object.entries(hours).map(([day, details]) => [
                    day,
                    details.slots
                        .filter(slot => slot.open || slot.close) // Ensure there are valid slots
                        .map(slot => ({
                            open: slot.open ? (slot.open instanceof Date ? formatTime(slot.open) : slot.open) : '',
                            close: slot.close ? (slot.close instanceof Date ? formatTime(slot.close) : slot.close) : '',
                            valid: slot.valid ?? true, // Assuming 'valid' can be true or undefined
                        }))
                ])
            );
        }

        const updateData = {
            lab_id: id,
            lab_name: values.lab_name,
            lab_code: values.lab_code,
            address: values.address,
            city: values.city,
            state: values.state,
            country: values.country,
            postalcode: values.postalcode,
            working_hours: working_hours
        };

        LabsService.updateLab(updateData)
        .then((data) => {              
            if (data.status == false) {
                setToastMessage(data.message);
                setToastVariant('error');
            } else {
                setToastMessage(data.message);
                setToastVariant('success');

                setTimeout(() => {
                    navigate(`${previousUrl}`);
                }, 1000);
            }

            setLoading(false);
            setShowToast(true);
        })
        .catch((error) => {
            setToastMessage(error.message || 'Something went wrong.');
            setShowToast(true);
            setToastVariant('error');
            setLoading(false);
        });        
                
    };    

    return (
        <>
            <Loader loading={loading} />
            <div className={`${!isSidebarVisible ? 'collapsed-body' : ''}`}>
                <div className="el-middle-wrapper">
                    <h2 className="el-title">
                        Edit Lab                       
                    </h2>
                    <Link className="back-link" to={`${previousUrl}`}><i className='el-icon-back'></i> Lab Hours</Link>

                    <div className="el-bg-table el-super-admin ps-4">
                        <Formik
                                initialValues={initialValues}
                                validationSchema={validationSchema}
                                onSubmit={handleSubmit}
                                enableReinitialize={true}
                            >
                                {({ values, errors, touched, setFieldValue }) => {

                                return (
                                <Form> 

                                    <div className="row col-xl-12"> 
                                        <div className="col-md-6">
                                            <label htmlFor="lab_name" className="form-label">Lab<span className="text-red">*</span></label>
                                            <Field
                                                name="lab_name"
                                                type="text"
                                                className="form-control"
                                                placeholder="Enter Lab Name" 
                                                value={values !== null ? values.lab_name : ''}                                              
                                            />
                                            <ErrorMessage name="lab_name" component="div" className="text-danger" />
                                        </div>
                                        <div className="col-md-6">
                                            <label htmlFor="lab_code" className="form-label">Lab Code<span className="text-red">*</span></label>
                                            <Field
                                                name="lab_code"
                                                type="text"
                                                className="form-control"
                                                placeholder="Enter Lab Code"
                                                innerRef={codeRef}
                                                onChange={(event) => handleCodeChange(event, setFieldValue)}
                                                value={values !== null ? values.lab_code : ''}
                                            />
                                            <ErrorMessage name="lab_code" component="div" className="text-danger" />
                                        </div>
                                    </div>

                                    <div className="row col-xl-12 mt-3">
                                        <div className="col-md-12">
                                            <label htmlFor="address" className="form-label">Address</label>
                                            <Field
                                                name="address"
                                                type="text"
                                                className="form-control"
                                                placeholder="Enter address"
                                                value={values !== null ? values.address : ''}
                                            />
                                            <ErrorMessage name="address" component="div" className="text-danger" />
                                        </div>
                                    </div>

                                    <div className="row col-xl-12 mt-3"> 
                                        <div className="col-md-6">
                                            <label htmlFor="city" className="form-label">City</label>
                                            <Field
                                                name="city"
                                                type="text"
                                                className="form-control"
                                                placeholder="Enter city"
                                                value={values !== null ? values.city : ''}
                                            />
                                            <ErrorMessage name="city" component="div" className="text-danger" />
                                        </div>
                                        <div className="col-md-6">
                                            <label htmlFor="state" className="form-label">State </label> 
                                            <Field
                                                name="state"
                                                type="text"
                                                className="form-control"
                                                placeholder="Enter state"
                                                value={values !== null ? values.state : ''}
                                            />
                                            <ErrorMessage name="state" component="div" className="text-danger" />
                                        </div>                                        
                                    </div>

                                    <div className="row col-xl-12 mt-3">                                         
                                        <div className="col-md-6">
                                            <label htmlFor="country" className="form-label">Country</label> 
                                            <Field
                                                name="country"
                                                type="text"
                                                className="form-control"
                                                placeholder="Enter country"
                                                value={values !== null ? values.country : ''}
                                            />
                                            <ErrorMessage name="country" component="div" className="text-danger" />
                                        </div>
                                        <div className="col-md-6">
                                            <label htmlFor="postalcode" className="form-label">Postal code</label> 
                                            <Field
                                                name="postalcode"
                                                type="text"
                                                className="form-control"
                                                placeholder="Enter postal code"
                                                value={values !== null ? values.postalcode : ''}
                                            />
                                            <ErrorMessage name="postalcode" component="div" className="text-danger" />
                                        </div>
                                    </div>
                                    
                                    <div className="el-super-admin mt-5 el-appoinment-duration">
                                        <div className="row">
                                            <div className="col-xl-12">
                                                {Object.keys(hours).map((day, index) => (
                                                    <div className="row mb-5" key={`${day}-${index}`}>
                                                        <div className="col-md-2">
                                                            <h3>{day}</h3>
                                                        </div>
                                                        <div className="col-md-2">
                                                            <div className="form-check form-switch">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="checkbox"
                                                                    checked={hours[day].enabled}
                                                                    onChange={() => handleToggle(day)}
                                                                />
                                                            </div>
                                                        </div>  

                                                        {hours[day].enabled ? (
                                                            <div className="row col-md-8 mb-2 el-add-hours">
                                                                {renderTimeSlots(day)}

                                                                <button
                                                                    type="button"
                                                                    className="el-main-button el-add-hours-btn"
                                                                    onClick={() => addTimeSlot(day)}
                                                                    disabled={!hours[day].enabled}
                                                                > <span> Add Hours</span></button>
                                                               
                                                            </div>  
                                                            
                                                        ) : (
                                                            <div className="col-md-4">
                                                              <h3>{hours[day]?.enabled ? "No Slots Available" : "Closed"}</h3>
                                                            </div>
                                                        )}
                                                                                                                   
                                                    </div>  
                                                ))}
                                            </div>
                                        </div>  
                                    </div>     
                                    <div className="d-flex align-items-center">
                                        <button type="submit" className="el-main-button">Submit</button>
                                        <Link className="back-link" to={`${previousUrl}`}>Close</Link>
                                    </div>

                                     

                                </Form>
                                );
                            }}
                        </Formik> 
                    </div>
                    <Toaster
                        show={showToast}
                        message={toastMessage}
                        variant={toastVariant}
                        onClose={() => setShowToast(false)}
                    />
                </div>
            </div>
        </>
    );
}

export default LabEdit;